import React from 'react';

import { Collapse } from '@mui/material';

import useStyles from './styles';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    icon: React.ComponentType<{ className?: string }>;
    title: string;
    active?: boolean;
    collapsed?: boolean;
    onClick?: () => void;
    className?: string;
}

const NavBarItem: React.FC<Props> = ({ icon: Icon, title, active, collapsed = false, onClick, className, ...rest }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.container, { [classes._active]: active }, className)} onClick={onClick} {...rest}>
            <Collapse in={collapsed === false} timeout={200} easing="ease-in-out">
                <Icon className={classes.icon} />
            </Collapse>
            <span className={classes.title}>{title}</span>
            <div data-role="indicator" className={cx(classes.indicator, { [classes._active]: active })} />
        </div>
    );
};

export default NavBarItem;
